import { Layout, Menu } from 'antd';
import {
  DashboardOutlined,
  TeamOutlined,
  FileTextOutlined,
  CalendarOutlined,
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';

const { Sider } = Layout;

const SideMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    { key: '/dashboard', icon: <DashboardOutlined />, label: 'Дашборд' },
    { key: '/team', icon: <TeamOutlined />, label: 'Команда' },
    { key: '/reports', icon: <FileTextOutlined />, label: 'Отчёты' },
    { key: '/meetings', icon: <CalendarOutlined />, label: 'Итоги встреч' },
  ];

  const selectedKey =
    items.find((item) => location.pathname.startsWith(item.key))?.key || '/dashboard';

  return (
    <Sider breakpoint="lg" collapsedWidth="0" style={{ background: '#001529' }}>
      <div
        style={{
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: 18,
          fontWeight: 'bold',
        }}
      >
        1:1 Meetings
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[selectedKey]}
        items={items}
        onClick={({ key }) => navigate(key)}
      />
    </Sider>
  );
};

export default SideMenu;
